import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Spinner } from "@/components/Shared";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Reset password" sub="We'll email you a link to choose a new password.">
      {done ? (
        <div className="space-y-4" data-testid="forgot-success">
          <p className="rounded-md border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-800">If an active account exists for that email, a reset link is on its way. It expires in 1 hour.</p>
          <Link to="/login" className="btn-ghost h-12 w-full" data-testid="forgot-back-login">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input type="email" required placeholder="you@company.com" className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
          <button className="btn-brand h-14 w-full" disabled={busy} data-testid="forgot-submit-button">{busy && <Spinner className="text-white" />}Send reset link</button>
          <Link to="/login" className="block text-center text-sm font-semibold text-[#5C241E]" data-testid="forgot-cancel-link">Back to sign in</Link>
        </form>
      )}
    </AuthShell>
  );
}
